import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Navbar.module.css";
import RookTechIcon from "../../images/RookTechIcon.png";
import { useTranslation } from "react-i18next";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const { t, i18n } = useTranslation();
  const [isLangOpen, setIsLangOpen] = useState(false);
  const languages = [
    { code: "en", label: "English" },
    { code: "pt", label: "Português" },
    { code: "es", label: "Español" },
    { code: "zh", label: "中文" },
    { code: "hi", label: "हिन्दी" },
    { code: "fr", label: "Français" },
    { code: "ar", label: "العربية" },
    { code: "bn", label: "বাংলা" },
    { code: "ru", label: "Русский" },
    { code: "ur", label: "اردو" },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.logo}>
        <Link to="/" className={styles.logoLink}>
          <img
            className={styles.navImage}
            src={RookTechIcon}
            alt="Logo Rook Tech"
          />
          <h1 className={styles.titleRT}>Rook Tech</h1>
        </Link>
      </div>

      <div className={styles.navRightSection}>
        <ul className={`${styles.navLinks} ${isMenuOpen ? styles.active : ""}`}>
          <li>
            <Link to="/" onClick={toggleMenu}>
              {t("navbar.home")}
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={toggleMenu}>
              {t("navbar.about")}
            </Link>
          </li>
          <li>
            <Link to="/services" onClick={toggleMenu}>
              {t("navbar.services")}
            </Link>
          </li>
          <li>
            <Link to="/mission" onClick={toggleMenu}>
              {t("navbar.vision")}
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={toggleMenu}>
              {t("navbar.contact")}
            </Link>
          </li>
        </ul>

        <div className={styles.langWrapper}>
          <button
            className={styles.langBtn}
            onClick={() => setIsLangOpen(!isLangOpen)}
          >
            {i18n.language.split("-")[0].toUpperCase()} ▾
          </button>

          {isLangOpen && (
            <div className={styles.langDropdown}>
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => {
                    i18n.changeLanguage(lang.code);
                    setIsLangOpen(false);
                  }}
                >
                  {lang.label}
                </button>
              ))}
            </div>
          )}
        </div>

        <div className={styles.menuIcon} onClick={toggleMenu}>
          <div className={isMenuOpen ? styles.barOpen1 : styles.bar}></div>
          <div className={isMenuOpen ? styles.barOpen2 : styles.bar}></div>
          <div className={isMenuOpen ? styles.barOpen3 : styles.bar}></div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
